import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import ReadMoreText from "./ReadMoreText";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function Services() {
  const [isSlider, setIsSlider] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSlider(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const servicesData = [
    {
      icon: "📊",
      title: "Data Selling & Licensing",
      desc: "Access structured, verified datasets across industries. Purchase once or subscribe for continuous updates — clean, reliable, ready to deploy.",
      tags: ["B2B Data", "Raw Datasets", "Custom Formats"],
      className: "first-service",
    },
    {
      icon: "🔍",
      title: "Data Enrichment",
      desc: "Transform your existing data with firmographic, demographic and behavioral layers — making it smarter and more actionable instantly.",
      tags: ["Enrichment", "Validation", "Cleansing"],
      className: "second-service",
    },
    {
      icon: "⚡",
      title: "Custom Intelligence Reports",
      desc: "Tailored reports that answer your exact business questions with verified data, trend analysis, and expert-layer insights.",
      tags: ["Reports", "Market Intel", "Analytics"],
      className: "third-service",
    },
    {
      icon: "🌐",
      title: "Data API Access",
      desc: "Integrate our data pipelines directly into your products via REST APIs. Real-time access, scalable infrastructure, dev-friendly docs.",
      tags: ["API", "Real-time", "Integration"],
      className: "fourth-service",
    },
    {
      icon: "🧠",
      title: "Data Strategy Consulting",
      desc: "Our experts help map your data needs to business goals — designing the right data architecture and strategy for scale.",
      tags: ["Strategy", "Consulting", "Advisory"],
      className: "fourth-service",
    },
    {
      icon: "🔒",
      title: "Compliant Data Delivery",
      desc: "All data ethically sourced, consent-verified, and fully DPDP-compliant. Every dataset delivered with a trust certificate.",
      tags: ["DPDP Compliant", "Ethical", "Secure"],
      className: "fourth-service",
    },
  ];

  return (
    <div id="services" className="services section service-page">
      <div className="container">

        {/* Header */}
        <div className="services-header">
          <span className="section-label">What We Do</span>
          <h2 className="section-title">Data Solutions for Every Scale</h2>
          <p className="section-sub">
            Whether you need raw datasets, enriched intelligence, or a full custom solution — we deliver what your business actually needs.
          </p>
        </div>

        {/* 🔁 CONDITION */}
        {isSlider ? (

          /* SLIDER (Mobile + Laptop) */
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            spaceBetween={20}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
            }}
          >
            {servicesData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className={`service-item ${item.className}`}>
                  <div className="service-icon">{item.icon}</div>
                  <h4>{item.title}</h4>
                  <ReadMoreText text={item.desc} />
                  {item.tags.map((tag, i) => (
                    <span className="tag" key={i}>{tag}</span>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        ) : (

          /* GRID (Desktop Only) */
          <div className="row">
            {servicesData.map((item, index) => (
              <div className="col-lg-4" key={index}>
                <div className={`service-item ${item.className}`}>
                  <div className="service-icon">{item.icon}</div>
                  <h4>{item.title}</h4>
				  <p>{item.desc}</p>
                  {item.tags.map((tag, i) => (
                    <span className="tag" key={i}>{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>

        )}

      </div>
    </div>
  );
}

export default Services;